import { CalibrationType } from "../interfaces/homography";

export const HomographyFilenames = {
    [CalibrationType.LPR]: 'homography-day.kml',
    [CalibrationType.NIGHTLPR]: 'homography-night.kml',
    [CalibrationType.MAP]: 'camera_gps_homography.yml',
};
